import { render, staticRenderFns } from "./DialogReject.vue?vue&type=template&id=c92edaa8&scoped=true"
import script from "./DialogReject.js?vue&type=script&lang=js&external"
export * from "./DialogReject.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92edaa8",
  null
  
)

export default component.exports